import seqStore from '../../store/seqStore'

export default function Length() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)
    const length = seqStore((state) => state.settings.length)
    const setLength = seqStore((state) => state.setLength)

    // LENGTH CONTROLS
    const handleLength = (e) => {
        const value = e.target.value
        setLength(currentTrack, value)
    }

    const resetLength = () => {
        setLength(currentTrack, 16)
    }
    
    return (
        <div id='lengthInput'>
            <label htmlFor="root note">Length <span>{length[currentTrack]}</span></label>
            <input id='enabledInput' type="range" min={1} max={16} step='1' value={length[currentTrack]} onChange={e => handleLength(e)} onDoubleClick={resetLength}/>
        </div>
    )
}
